import axiosInstance from "../../axios/axiosInstance";

export const groupApi = new class {

    getAllGroups = async () => {
        try {

            const resp: any = await axiosInstance.get(`/api/groups`);
            return resp.data

        } catch (error) {
            console.error("Error fetching company data:", error);
        }
    };


    getAllUsers = async () => {
        try {

            const resp: any = await axiosInstance.get(`/api/user?search=${""}&page=${1}&limit=15`);
            return resp.data.data.data

        } catch (error) {
            console.error("Error fetching company data:", error);
        }
    };
    async createGroup(data: any) {
        try {
            const resp: any = await axiosInstance.post(`/api/groups`, data);
            
            // Check if response indicates success
            if (resp.status === 200 || resp.status === 201) {
                // Verify the response contains valid data (group ID or data object)
                if (resp.data && (resp.data.id || resp.data.data?.id || resp.data.data)) {
                    return resp.data;
                }
                // If status is 200/201 but no valid data, it's still an error
                throw new Error(resp.data?.message || 'Group creation failed: No valid response data');
            }
            
            // If status is not 200/201, it's an error
            throw new Error(resp.data?.message || 'Failed to create group');
        } catch (error: any) {
            console.error("Error creating group:", error);
            
            // If error is already an Error object with message, re-throw it
            if (error instanceof Error && error.message) {
                throw error;
            }
            
            // Extract error message from axios error response
            const errorMessage = error?.response?.data?.message || 
                                error?.response?.data?.error || 
                                error?.response?.data?.body ||
                                error?.message || 
                                'Failed to create group. Please try again.';
            throw new Error(errorMessage);
        }
    }
    async updateGroup(id: number, data: any) {
        try {
            const resp: any = await axiosInstance.put(`/api/groups/${id}`, data);
            
            // Check if response indicates success
            if (resp.status === 200 || resp.status === 201) {
                // Verify the response contains valid data
                if (resp.data && (resp.data.id || resp.data.data?.id || resp.data.data)) {
                    return resp.data;
                }
                // If status is 200/201 but no valid data, it's still an error
                throw new Error(resp.data?.message || 'Group update failed: No valid response data');
            }
            
            // If status is not 200/201, it's an error
            throw new Error(resp.data?.message || 'Failed to update group');
        } catch (error: any) {
            console.error("Error updating group:", error);
            
            // If error is already an Error object with message, re-throw it
            if (error instanceof Error && error.message) {
                throw error;
            }
            
            // Extract error message from axios error response
            const errorMessage = error?.response?.data?.message || 
                                error?.response?.data?.error || 
                                error?.response?.data?.body ||
                                error?.message || 
                                'Failed to update group. Please try again.';
            throw new Error(errorMessage);
        }
    }
    async deleteGroup(id: number) {
        const resp: any = await axiosInstance.delete(`/api/groups/${id}`)
        return resp.data
    }
}();